import { type SetStateAction, type Dispatch, type ChangeEvent } from 'react'

import { type IEditRole } from '@/pages/Admins/helper'

import style from './Roles.module.scss'

interface IProps {
    login: string
    roles: IEditRole[]
    setRoles: Dispatch<SetStateAction<IEditRole[]>>
    onAddAdminRole: (login: string, roleName: string, onSuccess: () => void) => void
    onRemoveAdminRole: (login: string, roleName: string, onSuccess: () => void) => void
}

export const Roles = (props: IProps) => {
    const { login, roles, setRoles, onAddAdminRole, onRemoveAdminRole } = props

    return (
        <div className={style.container}>
            {roles.map((adminRole) => {
                const { role, roleDescription, isCheched } = adminRole

                const onCheckRoles = (e: ChangeEvent<HTMLInputElement>) => {
                    const isCheched = e.target.checked
                    if (isCheched) {
                        onAddAdminRole(login, role, () =>
                            setRoles((prev) => prev.map((r) => (r.role === role ? { ...r, isCheched } : r)))
                        )
                    } else {
                        onRemoveAdminRole(login, role, () =>
                            setRoles((prev) => prev.map((r) => (r.role === role ? { ...r, isCheched } : r)))
                        )
                    }
                }

                return (
                    <div key={role} className={style.roleWrapper}>
                        <input type='checkbox' checked={isCheched} onChange={onCheckRoles} />
                        <span className={style.role}>{roleDescription}</span>
                    </div>
                )
            })}
            {/* <div>
                <span>roles</span>
            </div> */}
        </div>
    )
}
